import ImageSnippetList from './ImageSnippetList';

export default ImageSnippetList;
